class CustomPincodeChecker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('.pincode-checker__input');
    this.button = this.querySelector('.pincode-checker__button');
    this.result = this.querySelector('.pincode-checker__result');

    this.sheetId = this.dataset.sheetId;
    this.range = this.dataset.sheetRange;
    this.apiKey = this.dataset.apiKey;
    this.colPincode = parseInt(this.dataset.colPincode) - 1;
    this.colMessage = parseInt(this.dataset.colMessage) - 1;
    this.colDays = parseInt(this.dataset.colDays) - 1;

    if (this.input) {
      this.input.setAttribute('maxlength', '6');
      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
      });
    }

    if (!this.input || !this.button || !this.result) {
      console.warn('PincodeChecker: Missing required elements.');
      return;
    }

    if (!this.sheetId || !this.range || !this.apiKey) {
      this.setResult('Missing Google Sheets configuration.', 'error');
      return;
    }

    this.button.addEventListener('click', () => this.checkPincode());
  }

  async checkPincode() {
    const pincode = this.input.value.trim();

    if (!pincode) {
      this.setResult('Please enter a pincode.', 'error');
      return;
    }

    if (!/^\d{6}$/.test(pincode)) {
      this.setResult('Enter a valid 6-digit pincode.', 'error');
      return;
    }

    this.setResult('Checking...', 'info');

    try {
      const data = await this.fetchSheetData();
      const match = data.find(row => row[this.colPincode] === pincode);

      if (!match) {
        this.setResult('Pincode not serviceable.', 'error');
        return;
      }

      const message = match[this.colMessage];
      const daysRaw = match[this.colDays];

      const dayMatches = daysRaw?.match(/\d+/g)?.map(Number) || [];

      if (dayMatches.length >= 2) {
        const [minDay, maxDay] = dayMatches;
        const startDate = this.getEstimatedDate(minDay);
        const endDate = this.getEstimatedDate(maxDay);
        this.setResult(`${message}<br><strong>Estimated Delivery:</strong> ${startDate} to ${endDate}`, 'success');
      } else if (dayMatches.length === 1) {
        const singleDate = this.getEstimatedDate(dayMatches[0]);
        this.setResult(`${message}<br><strong>Estimated Delivery:</strong> ${singleDate}`, 'success');
      } else {
        this.setResult(`${message}<br><strong>Estimated Delivery:</strong> Not available`, 'error');
      }

    } catch (err) {
      console.error('Pincode fetch error:', err);
      this.setResult('Something went wrong. Try again later.', 'error');
    }
  }

  async fetchSheetData() {
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${this.sheetId}/values/${this.range}?key=${this.apiKey}`;
    const response = await fetch(url);
    const json = await response.json();
    return json.values?.slice(1) || [];
  }

  getEstimatedDate(days) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toLocaleDateString(undefined, {
      weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  setResult(message, type = 'info') {
    this.result.className = `result ${type}`;
    this.result.innerHTML = message;
  }
}

customElements.define('custom-pincode-checker', CustomPincodeChecker);